import { Heading, Text, VStack } from '@televet/kibble-ui';
import React, { useMemo } from 'react';
import { useModularity } from 'shared/hooks/useModularity';

const SubscriptionSettings = (): JSX.Element | null => {
  const { isSubscriptionActive, isRecapTrialSubscription, recapTrialRemainingDays } = useModularity();

  const remainingDaysText = useMemo(() => {
    if (!isSubscriptionActive) {
      return 'Your free trial of AI Recap has ended.';
    }

    return `You've still got ${recapTrialRemainingDays} ${
      recapTrialRemainingDays === 1 ? 'day' : 'days'
    } left to use AI Recap for free. No subscription needed yet!`;
  }, [isSubscriptionActive, recapTrialRemainingDays]);

  if (!isRecapTrialSubscription) {
    return null;
  }

  return (
    <VStack pt={5} spacing={3} align="stretch">
      <Heading fontSize="2xl">{isSubscriptionActive ? 'Trial in progress' : 'Trial ended'} 🚀</Heading>
      <Text maxW="345px">{remainingDaysText}</Text>
    </VStack>
  );
};

export default SubscriptionSettings;
